import { render, staticRenderFns } from "./AsyncPage.vue?vue&type=template&id=282e5ab0"
import script from "./AsyncPage.vue?vue&type=script&lang=js"
export * from "./AsyncPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports